<template>
  <div
    v-if="show"
    class="px-3 marquee-container"
  >
    <i class="fas fa-volume-up my-auto pr-3 marquee-icon"></i>
    <NoticeBar
      class="notice-bar px-0"
      scrollable
      :speed="speed"
      :text="text"
    />
  </div>
</template>

<script>
import { NoticeBar } from 'vant';

export default {
  components: { NoticeBar },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      required: true
    },
    speed: {
      type: [String, Number],
      default: 40
    }
  }
};
</script>

<style scoped>
.marquee-container {
  display: flex;
  align-items: center;
  width: 100%;
  background: transparent;
  z-index: 10;
}

/* .notice-bar {
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 1rem;
  color: white !important;
  background: transparent;
  border-radius: 7px;
} */
.marquee-icon {
  color: #fff;
  font-size: 14px;
}

.notice-bar {
  flex: 1;
  height: 25px;
  font-size: 1rem;
  color: #fff;
  background: transparent;
  border-radius: 7px;
}
</style>